import React, { useEffect, useState, useLayoutEffect } from "react";
import { Row, Col } from "react-bootstrap"
import FilterReport from "./header/FilterReport"
import styles from "./style.module.css"
import { format, startOfMonth } from "date-fns"
import axiosService from "../../utils/axios.service";
import { Bar } from '@ant-design/plots';
import "./scss/report.scss"
import { Table, Spin } from 'antd';
import async from "async"
import 'antd/dist/antd.min.css'
import StorageService from "../../utils/storage.service";

const ReportUser = () => {
    const [title, setTitle] = useState("Theo nhân viên")
    const [startDate, setStartDate] = useState(format(new Date(startOfMonth(new Date())), "yyyy-MM-dd"))
    const [endDate, setEndDate] = useState(format(new Date(), 'yyyy-MM-dd'))
    const [store, setStore] = useState(
        (JSON.parse(StorageService.getItem("user_info")) && JSON.parse(StorageService.getItem("user_info")).role == 3) ?
            JSON.parse(StorageService.getItem("user_info")).stores[0].id
        : parseInt(StorageService.getItem("currentStore")) )
    const [isExport, setIsExport] = useState(false)
    const [loading, setLoading] = useState(true);
    const [chart, setChart] = useState([])
    const [table, setTable] = useState([])
    const [userAdmin, setUserAdmin] = useState(JSON.parse(StorageService.getItem("user_info")))

    const handleRangeDate = (sDate, eDate) => {
        setStartDate(sDate)
        setEndDate(eDate)
    }
    const handleStore = (x) => {
        setStore(x)
    }
    const fetchData = async (sD, eD, s) => {
        const { users, data } = await async.parallel({
            users: (cb) => {
                axiosService(`api/reports/store/users/${store}`, "GET").then(rs => {
                    const { data } = rs
                    cb(null, data)
                })
            },
            data: (cb) => {
                axiosService(`api/reports/users?startDate=${sD}&endDate=${eD}&store=${store}`, "GET").then(rs => {
                    const { data } = rs
                    cb(null, data)
                })
            }
        })
        if (data.code === 200) {
            setLoading(false)
            const { dataChart, dataTable } = data.data
            setChart(dataChart)
            setTable(dataTable)
        }

    }
    useLayoutEffect(() => {
        setLoading(true)
        fetchData(startDate, endDate, store)
    }, [startDate, endDate, store])

    const config = {
        data: chart,
        isStack: true,
        xField: 'value',
        yField: 'name',
        seriesField: 'type',
        label: false,
        xAxis: {
            label: {
                formatter: (v) => `${v}`.replace(/\d{1,3}(?=(\d{3})+$)/g, (s) => `${s},`),
            },
        },
        tooltip: {
            formatter: (data) => {
                return {
                    name: data.name,
                    value: convertCurrency(data.value)
                };
            },
        }
    };
    function convertCurrency(data) {
        let res = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data)
        return res;
    };
    const columns = [
        {
            title: 'Nhân viên',
            dataIndex: 'name',
            render: (data) => {
                return (
                    <>
                        <p>{data}</p>
                    </>
                )
            },
            sorter: (a, b) => a.name.length - b.name.length,
        },
    
        // {
        //     title: 'Vị trí',
        //     dataIndex: 'valueServe',
        //     align: "center",
        //     render: (data) => {
        //         return (
        //             <p className="text1">{convertCurrency(data)}</p>
        //         )
        //     },
        //     sorter: {
        //         compare: (a, b) => a.valueServe - b.valueServe,
        //         multiple: 2,
        //     },
        // },
        {
            title: 'Số lần phục vụ',
            dataIndex: 'countServe',
            align: "center",
            sorter: {
                compare: (a, b) => a.countServe - b.countServe,
                multiple: 3,
            },
        },
        {
            title: 'Số lần tư vấn',
            dataIndex: 'countColsult',
            align: "center",
            sorter: {
                compare: (a, b) => a.countColsult - b.countColsult,
                multiple: 2,
            },
        },
        {
            title: 'Doanh số tư vấn',
            dataIndex: 'valueConsult',
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{convertCurrency(data)}</p>
                )
            },
            sorter: {
                compare: (a, b) => a.valueConsult - b.valueConsult,
                multiple: 1,
            },
        },
    ];
    const handleExportData = () => {
        setIsExport(true)
        setTimeout(() => {
            setIsExport(false)
        }, 2000)
    }
    return (
        <div className={`container-fluid report-page ${styles.background}`}>
            <FilterReport startDate={startDate} endDate={endDate}
                handleRangeDate={handleRangeDate} store={store}
                handleStore={handleStore}
                title={title} type={"users"}
                csvData={table} isExport={isExport}
                handleExportData={handleExportData}
                header={
                    [
                        { label: 'Nhân viên', key: "name" },
                        { label: "Số lần phục vụ", key: "countServe" },
                        { label: "Doanh số phục vụ", key: "valueServe" },
                        { label: "Số lần tư vấn", key: "countColsult" },
                        { label: "Doanh số tư vấn", key: "valueConsult" },
                        { label: "Tổng doanh số", key: `total` }
                    ]
                }
                userAdmin={userAdmin}
            />
            <Spin spinning={loading} tip="Đang tải...">
                <Row className="pt-2">
                    <Col xs={4}>
                        <div style={{ backgroundColor: "white" }} className="p-2">
                            <div className="border-bottom w-100 mb-2">
                                Biểu đồ doanh số
                            </div>
                            <Bar {...config} />
                        </div>
                    </Col>
                    <Col xs={8}>
                        <div style={{ backgroundColor: "white" }} className="p-2">
                            <div className="border-bottom w-100 mb-2">
                                Bảng số liệu chi tiết
                            </div>
                            <Table 
                                columns={columns} 
                                dataSource={table}
                                pagination={{ pageSize: 10 }} 
                                scroll={{ x: 1300 }}
                                bordered
                            />
                        </div>
                    </Col>
                </Row>
            </Spin>
        </div>
    )
}
export default ReportUser